const DAY_MS = 86_400_000
const SATURDAY = 6

/** Band fill: a faint grey that reads on both themes. */
export const WEEKEND_BAND_COLOR = "hsl(var(--fg-secondary) / 0.1)"

type WeekendBand = { from: number; to: number; color: string }

/** One x-axis plot band per weekend (Saturday and Sunday, UTC) that overlaps
 * `[min, max]`. Daily points sit on midnight UTC and bars are centred on their
 * point, so each band starts half a day before Saturday and ends half a day
 * after Sunday to cover both bars. */
export function getWeekendBands(min: number, max: number): WeekendBand[] {
  // Search from the day before `min`, so a range that starts on a Sunday
  // still gets that weekend's band.
  const dayBefore = Math.floor(min / DAY_MS) * DAY_MS - DAY_MS
  const daysToSaturday = (SATURDAY - new Date(dayBefore).getUTCDay() + 7) % 7

  const bands: WeekendBand[] = []
  for (
    let saturday = dayBefore + daysToSaturday * DAY_MS;
    saturday <= max;
    saturday += 7 * DAY_MS
  ) {
    bands.push({
      from: saturday - DAY_MS / 2,
      to: saturday + 1.5 * DAY_MS,
      color: WEEKEND_BAND_COLOR,
    })
  }
  return bands
}
